// Terms of Service / Privacy Policy links shown on the welcome screen's
// consent line (see WelcomePage.tsx). Kept as constants, not env vars — a
// document URL change is a content update, not a per-environment config
// knob, and this way it doesn't need to propagate through
// .env.example / docker-compose / deploy workflows the way a real env var
// would.
//
// Published telegra.ph pages for docs/legal/{terms-of-service,privacy-policy}.md
// (Indonesian, canonical) and their .en.md English counterparts. Live as of
// 2026-09-22. tosURL/privacyURL below mirror internal/domain/legal.go's
// TOSURL/PrivacyURL exactly, so this remains the Mini App's own copy of the
// same per-language resolution rather than drifting from it.
const TOS_URL_ID = 'https://telegra.ph/Syarat--Ketentuan-Swipify-09-22'
const TOS_URL_EN = 'https://telegra.ph/Swipify-Terms-of-Service-09-22'
const PRIVACY_URL_ID = 'https://telegra.ph/Kebijakan-Privasi-Swipify-09-22'
const PRIVACY_URL_EN = 'https://telegra.ph/Swipify-Privacy-Policy-09-22-2'

/**
 * Resolves the Terms of Service link for lang (an i18next language code,
 * e.g. i18n.language from useTranslation()). English only when lang is
 * exactly 'en' — i18next already normalizes to one of SUPPORTED_LANGUAGES
 * before this is called — Indonesian otherwise, matching the document's
 * own text: the Indonesian version is canonical and governs if the
 * translations ever disagree.
 */
export function tosURL(lang: string): string {
  return lang === 'en' ? TOS_URL_EN : TOS_URL_ID
}

/** Resolves the Privacy Policy link for lang — see tosURL's doc comment. */
export function privacyURL(lang: string): string {
  return lang === 'en' ? PRIVACY_URL_EN : PRIVACY_URL_ID
}
